var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(0 -0.000976562)",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_3843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 16.999H15V18.999H13V16.999ZM13 20.999H15V22.999H13V20.999ZM17 16.999H19V18.999H17V16.999ZM17 20.999H19V22.999H17V20.999ZM21 16.999H23V18.999H21V16.999ZM21 20.999H23V22.999H21V20.999Z",
    fill: "#53DD6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44444 29.999H26.5556C27.9037 29.999 29 28.9226 29 27.599V10.799C29 9.47542 27.9037 8.39902 26.5556 8.39902H24.1111V5.99902H21.6667V8.39902H14.3333V5.99902H11.8889V8.39902H9.44444C8.09633 8.39902 7 9.47542 7 10.799V27.599C7 28.9226 8.09633 29.999 9.44444 29.999ZM27 11.999V27.999H9V11.999H27Z",
    fill: "#53DD6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_3843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 5.99902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.b50d2cda2f23e3b00deac3a1387f0ebf.svg";
export { ForwardRef as ReactComponent };